// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 12H19.5L12 22L4.5 12H9V2H15V12Z"}}]};

const ArrowTriangleDownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-triangle-down-filled',
    ref,
    icon: element,
  },
));

ArrowTriangleDownFilledIcon.displayName = 'ArrowTriangleDownFilledIcon';

export default ArrowTriangleDownFilledIcon;
